import React from 'react';
import { Button } from 'react-bootstrap';

const PageHeader = ({ title, subtitle, actionLabel, onAction, actionIcon = 'bi-plus-lg' }) => (
  <div className="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 className="mb-0">{title}</h4>
      {subtitle && <small className="text-muted">{subtitle}</small>}
    </div>
    {actionLabel && (
      <Button variant="primary" onClick={onAction}>
        <i className={`bi ${actionIcon} me-1`}></i>
        {actionLabel}
      </Button>
    )}
  </div>
);

export default PageHeader;
